import {
  FieldSection,
  FieldSectionTitle,
  FormContainer,
  FormRoleConfContext,
  FormSearchField,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { formRoleConf } from "./Management.formRoleConf"
import { ManagementEnum, type ManagementFormValues } from "./Management.schema"
import { lgoReferential } from "./referential"

export const Management = () => {
  const conf = useRoleConf(formRoleConf)

  return (
    <FormRoleConfContext.Provider value={conf}>
      <FormContainer>
        <FieldSectionTitle title="Affectation" />
        <FieldSection title="LGO" subtitle="LGO de l’officine">
          <FormSearchField<string, ManagementFormValues>
            label="LGO"
            name={ManagementEnum.LGO}
            options={lgoReferential}
            valueFormat="optionValue"
          />
        </FieldSection>
      </FormContainer>
    </FormRoleConfContext.Provider>
  )
}
